/* eslint-disable max-lines-per-function */
import { useState } from 'react'
import { useSelector } from 'react-redux'
import hanhDongChinhSua from '../../../constant/hanhDongChinhSua'
import chinhSuaVanBangProcessor from '../../../processor/chinhSuaVanBangProcessor'
import { dateToDDMMYY } from '../../../utils/date'
import ListVanBangWithView from '../ListVanBangWithView'
import ChuyenDieuChinh from './ChuyenDieuChinh'

const processor = chinhSuaVanBangProcessor

export default function VanBangChoDuyet() {
  const [selected, setSelected] = useState({})
  const [reload, setReload] = useState(false)
  const [visible, setVisible] = useState(false)
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)
  const toggle = () => setVisible(!visible)
  const duyet = async (id) => {
    if (confirm) {
      const dieuChinh = {
        vanBangId: id,
        type: hanhDongChinhSua.dongY,
      }
      const rs = await processor.upsert(dieuChinh)
      toast({
        type: rs.isSuccess ? 'success' : 'error',
        message: rs.isSuccess ? 'Chấp nhận yêu cầu thành công' : 'Chấp nhận yêu cầu thất bại',
      })
      if (rs.isSuccess) setReload(true)
    }
  }
  const buttons = [
    (data) => {
      return {
        icon: 'pi pi-check',
        className: 'p-button-rounded p-button-success mr-2',
        tooltip: 'Duyệt',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          confirm({
            action: () => duyet(data.id),
            body: `Bạn có muốn chấp nhận chỉnh sửa văn bằng này?`,
          })
        },
      }
    },
    (data) => {
      return {
        icon: 'pi pi-comment',
        className: 'p-button-rounded p-button-warning mr-2',
        tooltip: 'Phản hồi',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          setSelected({ ...data })
          toggle()
        },
      }
    },
  ]
  const submit = async (message) => {
    const dieuChinh = {
      vanBangId: selected.id,
      type: hanhDongChinhSua.trinhDuyet,
      ...message,
    }
    const rs = await processor.upsertForm(dieuChinh)
    toast({
      type: rs.isSuccess ? 'success' : 'error',
      message: rs.isSuccess ? 'Chuyển yêu cầu thành công' : 'Chuyển yêu cầu thất bại',
    })
    if (rs.isSuccess) setReload(true)
  }
  const additionColumn = [
    {
      value: 'chinhSuaVanBangs',
      name: 'Thông tin phản hồi',
      render: (data) => {
        return (
          <div>
            {data.chinhSuaVanBangs &&
              data.chinhSuaVanBangs
                .filter((item) => item.noiDung)
                .map((item) => (
                  <p>{`[${dateToDDMMYY(new Date(item.ngayTao))}] ${item.nguoiTao.fullname}: ${
                    item.noiDung
                  }`}</p>
                ))}
          </div>
        )
      },
    },
    {
      value: 'chinhSuaVanBangs',
      name: 'File đính kèm',
      render: (data) => {
        return (
          <div className="flex flex-column">
            {data.chinhSuaVanBangs &&
              data.chinhSuaVanBangs
                .filter((item) => item.fileDinhKem)
                .map(
                  (item) =>
                    item.fileDinhKem && (
                      <a
                        href={item.fileDinhKem}
                        download
                      >{`${item.nguoiTao.fullname}: ${item.noiDung}`}</a>
                    ),
                )}
          </div>
        )
      },
    },
  ]
  return (
    <>
      <ChuyenDieuChinh visible={visible} toggle={toggle} onSubmit={submit} />
      <ListVanBangWithView
        moduleTitle="Danh sách văn bằng chỉnh sửa chưa duyệt"
        buttons={buttons}
        getMethod={chinhSuaVanBangProcessor.getVanBangChinhSuaChoDuyet}
        reload={reload}
        setReload={setReload}
        additionColumn={additionColumn}
      />
    </>
  )
}
